/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* HANNA543: "stock | pre-order" option labels */
(function(){
  function fix(root){
    (root||document).querySelectorAll('.ProductForm__Option .ProductForm__Label').forEach(function(l){
      if(l.querySelector('.ProductForm__Sep')) return;
      var v=l.querySelector('.ProductForm__SelectedValue'); if(!v) return;
      var n=v.previousSibling;
      if(n&&n.nodeType===3){ n.textContent=n.textContent.replace(/:\s*$/,''); }
      var s=document.createElement('span'); s.className='ProductForm__Sep'; s.textContent='|';
      l.insertBefore(s,v);
    });
  }
  document.addEventListener('DOMContentLoaded',function(){fix();});
  document.addEventListener('variant:changed',function(){setTimeout(fix,0);});
  new MutationObserver(function(){fix();}).observe(document.documentElement,{childList:true,subtree:true});
})();
